import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Star, MapPin, ArrowRight } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=400";

const Card = ({ x }) => (
  <Link to={`/artista/${x.id}`} data-testid={`featured-card-${x.id}`} className="w-64 shrink-0 snap-start bg-white rounded-2xl border border-slate-200 overflow-hidden group hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300">
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={mediaUrl(x.media?.photos?.[0]) || FALLBACK} alt={x.companyName} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = FALLBACK; }} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
      <span className="absolute left-3 bottom-3 max-w-[85%] truncate text-[10px] font-bold px-2.5 py-1 rounded-full bg-white/90 text-aic-navy">{x.macroCategory}</span>
    </div>
    <div className="p-4">
      <div className="font-display font-bold text-aic-navy truncate">{x.companyName}</div>
      <div className="text-xs text-slate-500 mt-1 flex items-center gap-1 truncate"><MapPin className="w-3 h-3"/>{x.baseLocation}</div>
      {x.rating !== null && x.rating !== undefined && <div className="text-xs mt-2 flex items-center gap-1 text-aic-navy" data-testid={`featured-rating-${x.id}`}>
        <Star className="w-3.5 h-3.5 fill-[#E2A453] text-[#E2A453]"/><b>{Number(x.rating).toFixed(1)}</b>
        {x.reviewCount !== null && <span className="text-slate-500">({x.reviewCount} recensioni)</span>}</div>}
    </div>
  </Link>
);

export const FeaturedCarousel = () => {
  const [items, setItems] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    api.get("/artists").then((r) => setItems(r.data.filter((x) => x.premium).sort((a, b) => (b.rating || 0) - (a.rating || 0)).slice(0, 12))).catch(() => setItems([]));
  }, []);
  if (!items?.length) return null;
  const scroll = (d) => ref.current?.scrollBy({ left: d * 290, behavior: "smooth" });
  const Arrow = ({ d, Icon, id }) => (
    <button type="button" onClick={() => scroll(d)} data-testid={`featured-${id}`} aria-label={id === "prev" ? "Precedenti" : "Successivi"}
      className={`hidden md:flex absolute top-1/2 -translate-y-1/2 ${d < 0 ? "-left-5" : "-right-5"} z-10 w-11 h-11 rounded-full bg-white shadow-lg border border-slate-200 items-center justify-center text-aic-navy hover:bg-gold transition-colors`}><Icon className="w-5 h-5"/></button>
  );
  return (
    <section className="max-w-7xl mx-auto px-6 py-10" data-testid="home-featured">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-aic-navy">Artisti in evidenza</h2>
          <p className="text-sm text-slate-500 mt-1">I profili Premium più apprezzati della piattaforma.</p>
        </div>
        <Link to="/artisti" data-testid="featured-all" className="text-sm font-semibold text-aic-navy hover:text-[#C98A3C] inline-flex items-center gap-1 shrink-0">Vedi tutti gli artisti<ArrowRight className="w-4 h-4"/></Link>
      </div>
      <div className="relative">
        <Arrow d={-1} Icon={ChevronLeft} id="prev"/>
        <div ref={ref} className="flex gap-5 overflow-x-auto no-scrollbar snap-x scroll-smooth pb-4" data-testid="featured-track">
          {items.map((x) => <Card key={x.id} x={x}/>)}
        </div>
        <Arrow d={1} Icon={ChevronRight} id="next"/>
      </div>
    </section>
  );
};
